import { useUserStore } from '../store/userStore';

export type { BackendProfile } from '../store/userStore';

// Hook that provides same interface as old useUserContext
export const useUserContext = () => {
  const state = useUserStore();
  
  return {
    clerkUser: state.clerkUser,
    backendProfile: state.backendProfile,
    loading: state.loading,
    refreshUser: state.refreshUser,
    updateClerkUserName: state.updateClerkUserName,
    isAdmin: state.isAdmin,
    isTenantAdmin: state.isTenantAdmin,
    isLoaded: state.isLoaded,
    isSignedIn: state.isSignedIn,
    tenantAccess: state.tenantAccess,
    tenantAccessMessage: state.tenantAccessMessage,
  };
};

// Direct store access for non-component usage
export { useUserStore } from '../store/userStore';